/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer.js';
import { env_config } from '/server/static/widgets/customer-tickets/config/';
import { PUT } from '/client/src/api/';
import SimpleInput from '/client/src/components/forms/simpleInput';
import CssPinner from '/client/src/components/csspinner';

const IntegrationsWidgetEmbed = (): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);
  const [userCompanyUrl, setUserCompanyUrl] = React.useState(context.profileCurrent.ticket_widget_login_path || '');

  const saveUserCompanyUrl = async () => {
    try {
      CssPinner(document.body, true);

      await PUT('/api/v1/1/merchants/widget_login_path', {
        ticket_widget_login_path: userCompanyUrl
      });

      CssPinner(document.body, false);

      context.handleShowSystemDialog(true, {
        systemDialogType: 'success',
        systemDialogTitle: 'Great!',
        systemDialogContent: 'Website URL saved'
      });
    } catch (e) {
      context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: 'Can\'t save website URL'
      });

      CssPinner(document.body, false);
    }
  };

  return (
    <div className="preview-codes">
      <div className="panel panel-preview">
        <div className="panel-heading">
          <div className="panel-title">
            <span className="text">
              Ticket Widget
            </span>
          </div>
        </div>

        <div className="panel-body">
          <div className="input-group clearfix">
            <span className="input-group-addon">
              <i className="icon icon-code" />
            </span>

            <textarea
              rows="5"
              className="form-control"
              readOnly
              value={
              `<script src="${env_config['proxy-api-host']}/widgets/customer-tickets/vendor/initTicketWidget.js" />`
              }
            />
          </div>
        </div>

        <div className="panel-heading">
          <div className="panel-title">
            <span className="text">
              Company website URL
            </span>
          </div>
        </div>

        <div className="panel-body" style={{ display: 'flex' }}>
          <SimpleInput
            name={'userCompanyUrl'}
            id={'userCompanyUrl'}
            type={'text'}
            value={userCompanyUrl}
            style={{ margin: '0 10px 0 0', width: '100%' }}
            onChange={(e: SyntheticInputEvent<HTMLInputElement>): any => setUserCompanyUrl(e.target.value)}
          />

          <button
            type="button"
            className="btn btn-default"
            onClick={saveUserCompanyUrl}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default IntegrationsWidgetEmbed;
